<div ng-controller="adminStandardReportsController as ctrl">
    <c-simple-list configuration="ctrl.listConfig" items="ctrl.reports"></c-simple-list>
    <ui-view></ui-view>
</div>